import React, { useState } from "react";
import { TextField } from "@mui/material";
import { plateRegex } from "../../../../utils/consts";

export enum ERROR_TYPE {
  HIDE = "HIDE",
  COLOR = "COLOR",
  TEXT = "TEXT",
  BOTH = "BOTH",
}

interface Props {
  value: string;
  onChange: (plate: string) => void;
  errorType?: ERROR_TYPE;
  fullWidth?: boolean;
  hideLabel?: boolean;
}

/** Aplica a formatação de placa (AAA-0A00 / AAA-0000) visualmente */
function formatPlate(raw: string): string {
  const v = raw.replace(/[^A-Z0-9]/g, "").substring(0, 7);
  if (v.length <= 3) return v;
  return `${v.substring(0, 3)}-${v.substring(3)}`;
}

const PlateField: React.FC<Props> = ({
  value,
  onChange,
  errorType = ERROR_TYPE.TEXT,
  fullWidth = false,
  hideLabel = false,
}: Props) => {
  const [error, setError] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
    onChange(raw);
  };

  const handleBlur = () => {
    const isValid = plateRegex.test(value?.toUpperCase());
    if (value.length) {
      setError(!isValid);
    } else {
      setError(false);
    }
  };

  const showError =
    error && !!(errorType === ERROR_TYPE.BOTH || errorType === ERROR_TYPE.TEXT);
  const showColorError =
    error &&
    !!(errorType === ERROR_TYPE.BOTH || errorType === ERROR_TYPE.COLOR);

  return (
    <TextField
      fullWidth={fullWidth}
      required
      label={!hideLabel ? "Placa do veículo" : ""}
      value={formatPlate(value)}
      onChange={handleChange}
      onBlur={handleBlur}
      error={showError && error ? error : false}
      helperText={showError ? "Placa inválida" : ""}
      slotProps={{
        htmlInput: { maxLength: 8 },
        input: {
          style: {
            backgroundColor: showColorError ? "lightcoral" : "white",
          },
        },
      }}
    />
  );
};

export default PlateField;
